import { render, staticRenderFns } from "./DiscountAmount.vue?vue&type=template&id=021c28ae&"
import script from "./DiscountAmount.vue?vue&type=script&lang=ts&"
export * from "./DiscountAmount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports